import React from 'react';
import { Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import ShareIcon from '@mui/icons-material/MobileScreenShare';
import CollectionsBookmarkIcon from '@mui/icons-material/CollectionsBookmark';
import * as styles from './Footer.module.css';
import ClassMenu from './ClassMenu';
import useWindowDimensions from '../hooks/useWindowDimensions';

const isBrowser = typeof window !== 'undefined';
const passingSearch = isBrowser ? window.location.search.replace('?', '&') : '';

const getSkipPhone = () => {
  return isBrowser && !!localStorage.getItem('phone_number')
    ? '&skipPhone=true'
    : '';
};

const Footer = ({ contentfulId, userId, lesson }) => {
  const { width } = useWindowDimensions();
  const isMobile = width < 810;

  return (
    <div className={styles.containerClassMenu}>
      <Button
        href={`${
          process.env.GATSBY_APP_BASE_URL
        }/aula/${contentfulId}?s=baixar&utm_origin=SEO&SEOID=${userId}${getSkipPhone()}${passingSearch}`}
        className="outlined-btn btn-medium"
      >
        <DownloadIcon className={styles.iconStyle} />
        {isMobile ? 'Baixar' : 'Baixar aula'}
      </Button>
      <Button
        href={`${
          process.env.GATSBY_APP_BASE_URL
        }/aula/${contentfulId}?s=criarPlano&utm_origin=SEO&SEOID=${userId}${getSkipPhone()}${passingSearch}`}
        className="contained-btn btn-medium"
      >
        <CollectionsBookmarkIcon className={styles.iconStyle} />
        {isMobile ? 'Criar plano' : 'Criar plano de aula'}
      </Button>

      <Button
        href={`${
          process.env.GATSBY_APP_BASE_URL
        }/aula/${contentfulId}?s=whatsapp&utm_origin=SEO&SEOID=${userId}${getSkipPhone()}${passingSearch}`}
        className="outlined-btn btn-medium"
      >
        <ShareIcon className={styles.iconStyle} />
        {isMobile ? 'Enviar' : 'Enviar atividade'}
      </Button>

      {width > 0 && !isMobile && (
        <ClassMenu
          lesson={lesson}
          contentfulId={contentfulId}
          userId={userId}
        />
      )}
    </div>
  );
};

export default Footer;
